<ng-container *ngIf="!onlyTable">
    <div class="p-4 pb-3">
        <h6 class="fs-5 mb-0">Call History</h6>
        <small
        >Calls in System: <b>{{ this.logParams.totalRecords }}</b></small>
    </div>
    <div class="d-flex justify-content-start px-4 pb-4">
        <input
            type="search"
            placeholder="Search by Phone Number or Customer Name"
            class="search-text-input me-3"
            style="min-width: 394px"
            [ngClass]="{ loading: isLoading }"
            [(ngModel)]="logParams.name"
            (keyup)="callHistoryListDebounce({ searchText: logParams.name })"
            (keyup.enter)="callHistoryList({ searchText: logParams.name })"/>
        <ng-select
            class="me-3"
            style="min-width: 218px"
            placeholder="Customer Type"
            [clearable]="false"
            [searchable]="false"
            (change)="callHistoryList({ accountType: $event })">
            <ng-option
                [value]="accType"
                *ngFor="let accType of UserAccountTypeEnum">
                {{ accType | capitalize }}
            </ng-option>
        </ng-select>

        <ng-select
            class="me-3"
            style="min-width: 218px"
            placeholder="All calls"
            [clearable]="false"
            [searchable]="false"
            (change)="callHistoryList({ direction: $event, page: 0 })">
            <ng-option
                [value]="callType.id"
                *ngFor="
                    let callType of [
                        { id: 'in', name: 'Inbound' },
                        { id: 'out', name: 'Outbound' }
                    ]
                ">
                {{ callType.name | capitalize }}
            </ng-option>
        </ng-select>
        <div class="form-group date-fld me-3">
            <input
                type="text"
                class="form-control"
                placeholder="dd/mm/yyyy"
                #drp="bsDatepicker"
                bsDatepicker
                [bsConfig]="bsConfig"
                (bsValueChange)="callHistoryList({ date: $event.toString() })"/>
            <button type="submit">
                <svg-icon
                    (click)="drp.toggle()"
                    src="assets/images/inputs/date_input_calendar.svg"></svg-icon>
            </button>
        </div>
        <app-switcher
            theme="grey"
            *ngIf="!!user.permissions.adminDashboard.allCallLogs"
            [switchList]="logSwitchItems"
            (switched)="callHistoryList({ phoneNr: $event.id === 1 ? this.currentPhone : null })"></app-switcher>
    </div>
</ng-container>
<div
    class="w-100 d-flex justify-content-center pb-4"
    *ngIf="isLoading || !callHistory.length">
    <app-inline-spinner [spinnerConfig]="{ ldsLoader: true, showSpinner: isLoading }"></app-inline-spinner>
    <div
        class="no-results"
        *ngIf="!callHistory.length && !isLoading">
        <p>No records found</p>
    </div>
</div>

<div class="w-100 flex-grow-1 overflow-auto">
    <table
        class="table table-borderless table-hover align-middle"
        *ngIf="callHistory.length && !isLoading">
        <thead class="thead-white">
        <tr>
            <th
                class="fs-sm fw-normal text-nowrap ps-4"
                title="Inbound or outbound call">
                IN/OUT
            </th>
            <th
                class="fs-sm fw-normal text-nowrap sortable"
                [ngClass]="{
                        asc: logParams.ascOrDesc === 'ASC' && logParams.sort === 'twilio_calls.duration',
                        desc: logParams.ascOrDesc === 'DESC' && logParams.sort === 'twilio_calls.duration'
                    }"
                (click)="
                        callHistoryList({
                            sort: 'twilio_calls.duration',
                            ascOrDesc: logParams.ascOrDesc === 'ASC' ? 'DESC' : 'ASC'
                        })
                    ">
                DURATION
            </th>
            <th class="fs-sm fw-normal text-nowrap">FROM</th>
            <th class="fs-sm fw-normal text-nowrap">TO</th>
            <th class="fs-sm fw-normal text-nowrap">NOTES</th>
            <th class="fs-sm fw-normal text-nowrap">CUTOMER</th>
            <th class="fs-sm fw-normal text-nowrap">CUSTOMER TYPE</th>
            <th
                class="fs-sm fw-normal text-nowrap sortable"
                [ngClass]="{
                        asc: logParams.ascOrDesc === 'ASC' && logParams.sort === 'twilio_calls.createdAt',
                        desc: logParams.ascOrDesc === 'DESC' && logParams.sort === 'twilio_calls.createdAt'
                    }"
                (click)="
                        callHistoryList({
                            sort: 'twilio_calls.createdAt',
                            ascOrDesc: logParams.ascOrDesc === 'ASC' ? 'DESC' : 'ASC'
                        })
                    ">
                DATE
            </th>
            <th class="fs-sm fw-normal text-nowrap"></th>
        </tr>
        </thead>

        <tr
            *ngFor="let callHist of callHistory"
            class="call-log-row {{ callHist.status }}">
            <td
                class="fs-sm fw-normal text-nowrap ps-4"
                title="Direction/Duration">
                <svg-icon
                    [src]="
                        callHist.direction == 'out'
                            ? 'assets/images/call/outbound-call-icon.svg'
                            : 'assets/images/call/inbound-call-icon.svg'
                    "></svg-icon>
            </td>
            <td class="fs-sm fw-normal text-nowrap">{{ callHist.duration | duration }}</td>
            <td class="fs-sm fw-normal text-nowrap">
                {{ callHist.callFrom | replace : ' ' : '' | match : '(\\+\\d+)' : 'gi' | head | formatPhone }}
            </td>
            <td class="fs-sm fw-normal text-nowrap">
                {{ callHist.callTo | replace : ' ' : '' | match : '(\\+\\d+)' : 'gi' | head | formatPhone }}
            </td>
            <td class="fs-sm fw-normal">
                <div class="d-flex">
                    <div *ngIf="callHist.notesCount > 0" class="badge badge--floating bg-success px-1">{{ callHist.notesCount }}</div>
                    {{ +callHist.notesCount === 0 ? '-' : '' }}
                </div>
            </td>
            <td
                class="fs-sm fw-normal text-nowrap"
                *ngIf="callHist.firstname || callHist.surname">
                {{ callHist.firstname }} {{ callHist.surname }}
            </td>
            <td
                class="fs-sm fw-normal text-nowrap"
                *ngIf="!callHist.firstname && !callHist.surname">
                Unknown
            </td>
            <td class="fs-sm fw-normal text-nowrap">{{ callHist.accountType ?? 'Unknown' | capitalize }}</td>
            <td class="fs-sm fw-normal text-nowrap">{{ callHist.createdAt | date : 'dd MMM yyyy HH:mm' }}</td>
            <td class="d-flex">
                <svg-icon
                    class="hover"
                    src="assets/images/call/phone-handset.svg"
                    (click)="makeACallLog(callHist)"></svg-icon>
                <div
                    appDropdown
                    class="dropdown ys-dropdown-menu">
                    <span
                        class="hover"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <svg-icon src="assets/images/call/icon-menu-action.svg"></svg-icon>
                    </span>
                    <div class="dropdown-menu shadow-sm p-0 g-0" style="right: 0;">
                        <span class="dropdown-item text-primary py-2" [ngClass]="{ 'disabled': +callHist.notesCount === 0 }" (click)="showNotesFor(callHist)"> Show notes </span>
                        <span class="dropdown-item text-primary py-2 disabled"> Copy data </span>
                        <span class="dropdown-item text-primary py-2 disabled"> Another menu </span>
                    </div>
                </div>
            </td>
        </tr>
    </table>
</div>

<div class="w-100 p-4">
    <app-pagination [params]="logParams" (update)="callHistoryList()"></app-pagination>
</div>

<ng-template #notesTmpl>
    <div class="text-center"><app-inline-spinner [spinnerConfig]="{ ldsLoader: true, showSpinner: callNotes === null }"></app-inline-spinner></div>
    <div id="call-notes-cont" *ngIf="callNotes !== null">
        <div *ngFor="let note of callNotes" class="pb-1">
            <label class="fs-xs mb-1">
                {{ note.createdBy.contact?.firstname }} {{ note.createdBy.contact?.surname }} ({{
                note.createdAt | date : 'dd MMM yyyy @ HH:mm'
                }})</label>
            <div class="fs-sm" [innerHtml]="note.content | safeHTML"></div>
            <ng-container *ngIf="note.files.length > 0">
                <label class="fs-xs pt-2">Files({{note.files.length}}):</label>
                <div>
                    <ng-container *ngFor="let file of note.files; let i = index">
                        <a *ngIf="toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}"><img src="{{ env.apiPath + 'notes/file/' + file }}" width="30"/></a>
                        <a *ngIf="!toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}">{{ toolsService.getFileType(file) }}</a>&nbsp;
                    </ng-container>

                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
